import { Box, Button, Fab, Stack, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { dispatch } from "store";
import { deleteTrayThunk, getTraysByCabinThunk } from "store/reducers/vending";
import TrayCrudDialog from "pages/vending/tray/dialogs/TrayCrudDialog";
import TrayItem from "pages/vending/tray/list/TrayItem";
import { ExpandLess, ExpandMore, Refresh } from "@mui/icons-material";

const TrayList = ({ cabin, refill_mod = false }) => {
  const vendingState = useSelector((state) => state.vending);
  const [currentItem, setCurrentItem] = React.useState(null);

  const trays = useSelector((state) => state.vending.trays);

  useEffect(() => {
    dispatch(getTraysByCabinThunk(cabin.id));
  }, [cabin]);

  const handleDelete = (id) => {
    dispatch(deleteTrayThunk({ id, cabin_id: cabin.id }));
  };

  const handleClick = (item) => {
    console.log("In console");
    setCurrentItem(item);
    setOpenUpdateDialog(true);
  };

  const [openUpdateDialog, setOpenUpdateDialog] = React.useState(false);
  const handleUpdateDialogClose = () => {
    setOpenUpdateDialog(false);
  };

  const [openRows, setOpenRows] = React.useState(false);

  return (
    <Box marginTop={1}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack
          direction="row"
          alignItems="center"
          sx={{ width: "100%" }}
          justifyContent="space-between"
        >
          <Typography variant="h5" color="text.secondary">
            Trays in cabin {cabin.number}:
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {openRows ? (
              <Stack
                direction="row"
                alignItems="center"
                spacing={1}
                sx={{ cursor: "pointer", color: "green" }}
              >
                <span onClick={() => setOpenRows(false)}>Close all</span>
                <ExpandLess />
              </Stack>
            ) : (
              <Stack
                direction="row"
                alignItems="center"
                spacing={1}
                sx={{ cursor: "pointer", color: "green" }}
              >
                <span onClick={() => setOpenRows(true)}>Expand all</span>
                <ExpandMore />
              </Stack>
            )}
            {!refill_mod && (
              <Button
                size="small"
                variant="outlined"
                sx={{ mt: 1 ,ml:1}}
                onClick={() => setOpenUpdateDialog(true)}
              >
                Add new tray
              </Button>
            )}
          </Box>
        </Stack>
      </Stack>

      <Box sx={{ mt: 2 }}>
        {trays[cabin.id]?.map((tray) => (
          <TrayItem
            key={tray.id}
            tray={tray}
            handleClick={handleClick}
            handleDelete={handleDelete}
            refill_mod={refill_mod}
            openRows={openRows}
          />
        ))}
      </Box>

      <TrayCrudDialog
        open={openUpdateDialog}
        handleClose={handleUpdateDialogClose}
        cabin_id={cabin.id}
        tray={currentItem}
        setCurrentItem={setCurrentItem}
        number={
          vendingState.trays[cabin.id]?.length > 0
            ? vendingState.trays[cabin.id][
                vendingState.trays[cabin.id]?.length - 1
              ].number + 1
            : 1
        }
      />
      <Fab
        sx={{
          margin: 0,
          top: "auto",
          right: { xs: 40, sm: 30, md: 50, lg: 70, xl: 70 },
          bottom: 30,
          left: "auto",
          position: "fixed",
        }}
        size="medium"
        color="primary"
        onClick={() => dispatch(getTraysByCabinThunk(cabin.id))}
      >
        <Refresh />
      </Fab>
    </Box>
  );
};

export default TrayList;
